import { NavigationItem, PartnerFragment } from '@amf/shared/types/graphql';
import { ReactNode } from 'react';
import MainLayout from '@amf/shared/components/layout/Layout';
import Navigation from '@amf/shared/components/navigation/Navigation';
import { useTranslate } from '@tolgee/react';
import BrandCNP from '@amf/shared/icons/brands/BrandCNP';

import Footer from 'components/layout/Footer';
import { AppLinks, ExternalLinks } from 'utils/links';

interface LayoutProps {
  navigation: NavigationItem[];
  partners: PartnerFragment[];
  children: ReactNode;
}

function Layout({ navigation, partners, children }: LayoutProps) {
  const { t } = useTranslate();
  return (
    <MainLayout footer={<Footer partners={partners} />}>
      <Navigation
        variant='blue'
        navigation={navigation}
        brand={<BrandCNP />}
        search={AppLinks.search}
        buttonTitle={t('navigation.menu.account')}
        buttonLink={ExternalLinks.playerPortal}
        buttonProps={{
          variant: 'white-outline',
        }}
      />
      {children}
    </MainLayout>
  );
}

export default Layout;
